import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PartsPanel from './PartsPanel';
import NoteWithStamp from './NoteWithStamp';
import { partsForVehicleScope, tabPartsEnabled, tabPartFilesEnabled } from './partsUtils';
import { getCatalogParts } from '../../actions/apiGetInfo';
import { addVehiclePropertyVehicleRefresh } from '../../actions/AllUpdates';

const VEHICLE_PARTS_NOTE_KEY = 'vehicle_parts_note';

const VehiclePartsSection = ({
  vehicle, vehicle_id, tab, title = 'Vehicle Parts',
}) => {
  const dispatch = useDispatch();
  const store_vehicle = useSelector(state => state.settings_refresh?.active_vehicle || {});
  const catalog_parts = useSelector(state => state.settings_refresh?.catalog_parts || []);
  const all_tabs = useSelector(state => state.settings_site?.all_tabs || []);
  const active_vehicle = vehicle || store_vehicle;
  const vehicleId = vehicle_id || active_vehicle?.id;

  const enabled = useMemo(() => tabPartsEnabled(all_tabs, tab), [all_tabs, tab]);
  const showFiles = useMemo(() => tabPartFilesEnabled(all_tabs, tab), [all_tabs, tab]);
  const parts = useMemo(() => partsForVehicleScope(active_vehicle), [active_vehicle]);

  const noteProp = (active_vehicle?.vehicle_properties || []).find(p => p.key === VEHICLE_PARTS_NOTE_KEY);
  const savedNote = noteProp?.value || '';
  const [note, setNote] = useState(savedNote);

  useEffect(() => {
    if (enabled && !catalog_parts.length) dispatch(getCatalogParts());
  }, [enabled]);

  const saveNote = () => {
    if ((note || '') === (savedNote || '')) return;
    const data = { vehicle_id: vehicleId, key: VEHICLE_PARTS_NOTE_KEY, value: note };
    if (noteProp?.id) data.id = noteProp.id;
    dispatch(addVehiclePropertyVehicleRefresh(data, 'vehiclePartsNote'));
  };

  if (!enabled || !vehicleId) return null;

  return (
    <PartsPanel
      vehicleId={vehicleId}
      parts={parts}
      scope="vehicle"
      title={title}
      showTotals
      showFiles={showFiles}
      vehicleSubdomain={active_vehicle?.subdomain}
    >
      <NoteWithStamp
        value={note}
        onChange={e => setNote(e.target.value)}
        onBlur={saveNote}
        byUid={noteProp?.uid}
        byDate={noteProp?.updated_at}
      />
    </PartsPanel>
  );
};

export default VehiclePartsSection;
